  import apiServices from '../apiServices';

export const authApi = {
  // Login
  login: async (credentials) => {
    const response = await apiServices.post('api/v1/auth/admin/login', credentials);
    return response.data;
  },

  // Register
  register: async (userData) => {
    const response = await apiServices.post('/api/v1/auth/register', userData);
    return response.data;
  },

  // Forgot Password
  forgotPassword: async (email) => {
    const response = await apiServices.post('/api/v1/auth/forgot-password', { email });
    return response.data;
  },

  // Reset Password
  resetPassword: async (email, otp, password) => {
    const response = await apiServices.post('/api/v1/auth/reset-password', { email, otp, password });
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await apiServices.get('/api/v1/auth/me');
    return response.data;
  },

  // Update profile
  updateProfile: async (userData) => {
    const response = await apiServices.put('/api/v1/auth/profile', userData);
    return response.data;
  },

  // Change password
  changePassword: async (passwords) => {
      const response = await apiServices.put('/api/v1/auth/change-password', passwords);
    return response.data;
  },

  // Logout
  logout: async () => {
    const response = await apiServices.post('/auth/logout');
    return response.data;
  },
};
